import { createReducer } from '@common/redux-utils';
import {
  GetProfileFailureAction,
  GetProfileStartAction,
  GetProfileSuccessAction,
  ProfileActionType,
  SaveProfileFailureAction,
  SaveProfileStartAction,
  SaveProfileSuccessAction
} from './profile.actions';
import { ProfileViewModel } from '@models/Auth';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface ProfileState {
  message: string;
  currentProfile: ProfileViewModel | null;
}

// This is the initial state of the page
const initialState: ProfileState = {
  message: 'Initialized',
  currentProfile: null
};

/********** Save **********/
function handleSaveProfileStart(state: ProfileState, action: SaveProfileStartAction): ProfileState {
  return state;
}

function handleSaveProfileSuccess(state: ProfileState, action: SaveProfileSuccessAction): ProfileState {
  if (!action.profileId) {
    return state;
  }
  return {
    ...state,
    message: 'SUCCESS - user profile saved - ' + action.profileId
  };
}

function handleSaveProfileFailure(state: ProfileState, action: SaveProfileFailureAction): ProfileState {
  if (!action.errorMessage) {
    return state;
  }
  return {
    ...state,
    message: 'ERROR - save user profile failed - ' + action.errorMessage
  };
}

/********** Get **********/
function handleGetProfileStart(state: ProfileState, action: GetProfileStartAction): ProfileState {
  return state;
}

function handleGetProfileSuccess(state: ProfileState, action: GetProfileSuccessAction): ProfileState {
  if (!action.currentProfile) {
    return state;
  }
  return {
    ...state,
    currentProfile: action.currentProfile,
    message: 'SUCCESS - get user profile done - ' + action.currentProfile.id
  };
}

function handleGetProfileFailure(state: ProfileState, action: GetProfileFailureAction): ProfileState {
  if (!action.errorMessage) {
    return state;
  }
  return {
    ...state,
    message: 'ERROR - get user profile failed - ' + action.errorMessage
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const ProfileReducer = createReducer(initialState, {
  /********** Save **********/
  [ProfileActionType.SaveProfileStart]: handleSaveProfileStart,
  [ProfileActionType.SaveProfileSuccess]: handleSaveProfileSuccess,
  [ProfileActionType.SaveProfileFailure]: handleSaveProfileFailure,

  /********** Get **********/
  [ProfileActionType.GetProfileStart]: handleGetProfileStart,
  [ProfileActionType.GetProfileSuccess]: handleGetProfileSuccess,
  [ProfileActionType.GetProfileFailure]: handleGetProfileFailure
});



// WEBPACK FOOTER //
// ./src/profile/profile.reducer.ts